


// import React, { createContext, useContext, useRef, useState, useCallback } from 'react';
// import jDataView from 'jdataview';

// const WebSocketContext = createContext(null);

// export const WebSocketProvider = ({ children, onMessageCallback }) => {
//   const SOCKET_URL = 'wss://openapi.motilaloswaluat.com/jwebsocket/jwebsocket';
//   const DATA_BLOCK_SIZE = 30;

//   const [receivedData, setReceivedData] = useState([]);
//   const wsRef = useRef(null);
//   const reconnectTimeoutRef = useRef(null);

//   const isSocketOpen = (ws) => ws && ws.readyState === WebSocket.OPEN;

//   const connectWebSocket = useCallback(() => {
//     if (wsRef.current) return;

//     wsRef.current = new WebSocket(SOCKET_URL);
//     wsRef.current.binaryType = 'arraybuffer';

//     wsRef.current.onopen = () => {
//       console.log('WebSocket connected');
//       wsRef.current.send(constructBuffer());
//     };

//     wsRef.current.onclose = (event) => {
//       console.log('WebSocket disconnected:', event.reason);
//       wsRef.current = null;
//       if (!event.wasClean) {
//         clearTimeout(reconnectTimeoutRef.current);
//         reconnectTimeoutRef.current = setTimeout(connectWebSocket, 5000);
//       }
//     };

//     wsRef.current.onerror = (error) => {
//       console.error('WebSocket Error:', error);
//     };

//     wsRef.current.onmessage = (event) => {
//       handleIncomingMessage(event);
//     };
//   }, []);

//   const constructBuffer = (id = localStorage.getItem('email') || 'VIKRAM00&') => {
//     const arrbuffer = new ArrayBuffer(114);
//     const view = new jDataView(arrbuffer, 0, arrbuffer.byteLength, true);
//     const version = 'VER 2.0';

//     view.setChar(0, 'Q');
//     view.setUint16(1, 111, true);
//     view.setInt8(3, id.length, true);
//     const id_pad = pad(id, 15, ' ', 2);
//     view.setString(4, id_pad, '');

//     view.setInt8(19, id.length, true);
//     const name_pad = pad(id, 30, ' ', 2);
//     view.setString(20, name_pad, '');

//     view.setInt8(50, 1, true);
//     view.setInt8(51, 1, true);
//     view.setInt8(52, 1, true);

//     view.setInt8(53, version.length, true);
//     const ver_pad = pad(version, 10, ' ', 2);
//     view.setString(54, ver_pad, '');

//     view.setInt8(64, 0, true);
//     view.setInt8(65, 0, true);
//     view.setInt8(66, 0, true);
//     view.setInt8(67, 0, true);
//     view.setInt8(68, 1, true);

//     for (let i = 0; i < 45; i++) {
//       view.setInt8(69 + i, 0, true);
//     }

//     return arrbuffer;
//   };

//   const pad = (str, len, ch, type) => {
//     str = '' + str;
//     const padlen = len - str.length > 0 ? len - str.length : 0;
//     return type === 1 ? ch.repeat(padlen) + str : str + ch.repeat(padlen);
//   };

//   const constructBinaryMessage = (data) => {
//     if (!data || data.length < 4) {
//       console.error('Invalid input data. Expected at least 4 values.');
//       return null;
//     }

//     const buffer = new ArrayBuffer(10);
//     const view = new DataView(buffer);

//     view.setUint8(0, 'D'.charCodeAt(0));
//     view.setUint16(1, 7, true);
//     view.setUint8(3, data.exchange.charCodeAt(0));
//     view.setUint8(4, data.exchangeType.charCodeAt(0));
//     view.setInt32(5, data.scripCode, true);
//     view.setUint8(9, data.subscriptionState);

//     return buffer;
//   };

//   const subscribeSymbol = (values) => {
//     if (isSocketOpen(wsRef.current)) {
//       wsRef.current.send(constructBinaryMessage(values));
//     } else {
//       console.error('WebSocket is not open. Cannot send subscription message.');
//     }
//   };

//   const handleIncomingMessage = (event) => {
//     const buffer = event.data;
//     const messageCount = buffer.byteLength / DATA_BLOCK_SIZE;

//     const newData = [];

//     for (let i = 0; i < messageCount; i++) {
//       const view = new DataView(buffer, i * DATA_BLOCK_SIZE, DATA_BLOCK_SIZE);
//       const exchangeCode = String.fromCharCode(view.getUint8(0));
//       const scriptCode = view.getInt32(1, true);
//       const messageType = String.fromCharCode(view.getUint8(9));

//       if (messageType === '1') {
//         console.log('Heartbeat received');
//       }

//       if (messageType === 'A') {
//         const ltp = view.getFloat32(10, true).toFixed(2);
//         const quantity = view.getInt32(14, true);
//         const volume = view.getInt32(18, true);
//         const weightedAvgPrice = view.getFloat32(22, true).toFixed(2);
//         const openInterest = view.getFloat32(26, true).toFixed(2);

//         const dataObj = { ltp, quantity, volume, weightedAvgPrice, openInterest, scriptCode, exchangeCode };

//         if (!receivedData.some(d => JSON.stringify(d) === JSON.stringify(dataObj))) {
//           newData.push(dataObj);
//           if (onMessageCallback) {
//             onMessageCallback(dataObj);
//           }
//         }
//       }
//     }

//     if (newData.length > 0) {
//       setReceivedData((prevData) => [...prevData, ...newData]);
//     }
//   };

//   return (
//     <WebSocketContext.Provider value={{ connectWebSocket, subscribeSymbol, receivedData }}>
//       {children}
//     </WebSocketContext.Provider>
//   );
// };

// export const useWebSocket = () => {
//   return useContext(WebSocketContext);
// };

import { createContext, useContext, useEffect, useRef } from 'react';


const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children }) => {
  const SOCKET_URL = 'wss://ws1feed.motilaloswal.com/jwebsocket/jwebsocket';
  const wsRef = useRef(null);
  const DATA_BLOCK_SIZE = 30;

  function pad(str, length, char = ' ', type = 2) {
    if (typeof str !== 'string') str = String(str);
    if (str.length >= length) return str;

    const padLength = length - str.length;
    const padStr = char.repeat(padLength);

    if (type === 1) return padStr + str; // Left padding
    if (type === 2) return str + padStr; // Right padding

    return str; // Default: No padding
  }
  const isSocketOpen = (ws) => ws && ws.readyState === WebSocket.OPEN;

  const connectWebSocket = () => {
    wsRef.current = new WebSocket(SOCKET_URL);
    wsRef.current.binaryType = 'arraybuffer';

    wsRef.current.onopen = () => {
      if (isSocketOpen(wsRef.current)) {
        console.log('WebSocket connected');
        // console.log(constructBuffer() ,"obje")
        wsRef.current.send([]); // Send authentication buffer
      }
    };

    wsRef.current.onclose = (event) => {
      console.log('WebSocket disconnected:', event.reason);
      setTimeout(connectWebSocket, 2000); // Auto-reconnect
    };

    wsRef.current.onerror = (error) => {
      console.error('WebSocket Error:', error);
    };

    wsRef.current.onmessage = (event) => {
      handleIncomingMessage(event);
    };
  };

  const disconnectWebSocket = () => {
    if (isSocketOpen(wsRef.current)) {
      wsRef.current.close();
    }
  };

  const subscribeSymbol = (values, callback) => {
    if (!isSocketOpen(wsRef.current)) {
      console.error('WebSocket is not open. Cannot subscribe.');
      return;
    }

    // Send subscription message to WebSocket server
    const binaryMessage = constructBinaryMessage(values, 1); // 1 means subscribe
    if (binaryMessage) {
      wsRef.current.send(binaryMessage);
    }

    // Store the callback to notify component later
    wsRef.current.addEventListener('message', (event) => {
      handleIncomingMessage(event, callback);
    });
  };

  const unsubscribeSymbol = (values) => {
    if (!isSocketOpen(wsRef.current)) {
      console.error('WebSocket is not open. Cannot unsubscribe.');
      return;
    }

    // Send unsubscription message
    const binaryMessage = constructBinaryMessage(values, 0); // 0 means unsubscribe
    if (binaryMessage) {
      wsRef.current.send(binaryMessage);
    }
  };

  const sendHeartbeat = () => {
    try {
      const buffer = new ArrayBuffer(3);
      const view = new DataView(buffer);
      view.setUint8(0, '1'.charCodeAt(0));
      view.setUint16(1, 0, true);

      if (isSocketOpen(wsRef.current)) {
        wsRef.current.send(buffer);
      }
    } catch (error) {
      console.error('Error sending heartbeat:', error);
    }
  };

  

  function constructBuffer(id = localStorage.getItem('email')) {
    const arrBuffer = new ArrayBuffer(114);
    const view = new DataView(arrBuffer);
    const encoder = new TextEncoder();
    const version = 'VER 2.0';

    view.setUint8(0, 'Q'.charCodeAt(0)); // Set 'Q' at position 0
    view.setUint16(1, 111, true);
    view.setUint8(3, id.length);

    const idPad = pad(id, 15, ' ', 2);
    encoder.encodeInto(idPad, new Uint8Array(arrBuffer, 4, 15));

    view.setUint8(19, id.length);
    const namePad = pad(id, 30, ' ', 2);
    encoder.encodeInto(namePad, new Uint8Array(arrBuffer, 20, 30));

    view.setUint8(50, 1);
    view.setUint8(51, 1);
    view.setUint8(52, 1);

    view.setUint8(53, version.length);
    const verPad = pad(version, 10, ' ', 2);
    encoder.encodeInto(verPad, new Uint8Array(arrBuffer, 54, 10));

    for (let i = 64; i < 114; i++) {
      view.setUint8(i, 0);
    }

    return arrBuffer;
  }

  const constructBinaryMessage = (data, subscriptionStatus) => {
    if (!data || data.length < 4) {
      console.error('Invalid input data. Expected at least 4 values.');
      return null;
    }

    const buffer = new ArrayBuffer(10);
    const view = new DataView(buffer);

    view.setUint8(0, 'D'.charCodeAt(0));
    view.setUint16(1, 7, true);
    view.setUint8(3, data.exchange.charCodeAt(0));
    view.setUint8(4, data.exchangeType.charCodeAt(0));
    view.setInt32(5, data.scripCode, true);
    view.setUint8(9, subscriptionStatus); // 1 for subscribe, 0 for unsubscribe

    return buffer;
  };

  const handleIncomingMessage = (event, callback) => {
    const buffer = event.data;
    const messageCount = buffer.byteLength / DATA_BLOCK_SIZE;

    for (let i = 0; i < messageCount; i++) {
      const view = new DataView(buffer, i * DATA_BLOCK_SIZE, DATA_BLOCK_SIZE);
      const scriptCode = view.getInt32(1, true);
      const messageType = String.fromCharCode(view.getUint8(9));

      if (messageType === '1') {
        sendHeartbeat();
      }

      if (messageType === 'A') {
        const ltp = view.getFloat32(10, true).toFixed(2);
        const quantity = view.getInt32(14, true);
        const volume = view.getInt32(18, true);
        const weightedAvgPrice = view.getFloat32(22, true).toFixed(2);
        const openInterest = view.getFloat32(26, true).toFixed(2);

        // Notify the component with the live data
        if (callback) {
          callback({ ltp, quantity, volume, weightedAvgPrice, openInterest, scriptCode });
        }
      }
    }
  };

  // useEffect(() => {
  //   connectWebSocket();
  //   return () => {
  //     disconnectWebSocket();
  //   };
  // }, []);

  return (
    <WebSocketContext.Provider value={{ subscribeSymbol, unsubscribeSymbol, disconnectWebSocket,connectWebSocket }}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocket = () => useContext(WebSocketContext);






